import layout from '@/layout/index.vue'

export default {
  path: '/base_point',
  component: layout,
  redirect: '/base_point/goods/list',
  name: 'goodsLists',
  meta: {
    title: '扣库（菜品）',
    icon: 'goods'
  },
  children: [
    // 菜品库分类
    {
      path: '/config/common_goods_category',
      name: 'config_common_goods_category',
      component: () => import('@/views/config/common_goods_category/index'),
      meta: {
        title: '菜品库分类',
        icon: 'goods'
      }
    },
    // 菜品库
    {
      path: '/config/common_goods',
      name: 'config_common_goods',
      component: () => import('@/views/config/common_goods/index'),
      meta: {
        title: '菜品库',
        icon: 'goods'
      }
    },
    // 门店菜品
    {
      path: '/config/goods',
      name: 'config_goods',
      component: () => import('@/views/config/goods/index'),
      meta: {
        title: '门店菜品',
        icon: 'goods'
      }
    },
    {
      path: '/config/order',
      name: 'config_order',
      component: () => import('@/views/config/order/index'),
      meta: {
        title: '订单扣库存',
        icon: 'goods'
      }
    },
    // {
    //   path: '/base_point/goods/list',
    //   name: 'goodsList',
    //   component: () => import('@/views/goods/list/index.vue'),
    //   meta: {
    //     title: '菜品库',
    //     icon: 'goods'
    //   }
    // },
    {
      path: '/base_point/index',
      name: 'basePointIndex',
      component: () => import('@/views/base_point/index.vue'),
      meta: {
        title: '基点',
        icon: 'goods'
      }
    },
    {
      path: '/base_point_group/index',
      name: 'basePointGroupIndex',
      component: () => import('@/views/base_point_group/index.vue'),
      meta: {
        title: '基点组',
        icon: 'goods'
      }
    },
    // {
    //   path: '/base_point/order',
    //   name: 'basePointOrder',
    //   component: () => import('@/views/order/index.vue'),
    //   meta: {
    //     title: '基点扣库',
    //     icon: 'goods'
    //   }
    // },
    {
      path: '/base_point/stock_adjust',
      name: 'basePointStockAdjust',
      component: () => import('@/views/stock_adjust/index.vue'),
      meta: {
        title: '库存调平',
        icon: 'goods'
      }
    },
    {
      path: '/base_point/stock_alert',
      name: 'basePointStockAlert',
      component: () => import('@/views/stock_alert/index.vue'),
      meta: {
        title: '库存预警',
        icon: 'goods'
      }
    }
  ]
}
